"use strict"

export class FormMessage {

    constructor(langCode, selector, options) {

        this.selector = selector;
        this.options = $.extend( {
            alertSelector: '.alert-required'
        }, options);
        this.langCode=langCode;
        
        this.init();

    }
    
    init(){
        var fm = this;
        $(document).delegate('form', 'submit', function(e){
            if(fm.validateForm($(this))){
                return true;
            }else{
                e.stopPropagation();
                e.stopImmediatePropagation();
                fm._scrollTo();
                return false;
            }
        });
        var select = 'form '+this.selector+' input,'
        +'form '+this.selector+' textarea,'
        + 'form '+this.selector+' select'
        $(document).delegate(select, 'change', function(e){
            fm.validateFormElement($(this).closest(fm.selector));
            try {
                // time a date inputy dělají neplechu > pokud byl veden jako nevyplněný A nyní je vyplněný, tak to roluje na další nevyplněný ještě během vyplňování, takže to zabijeme...
                if (
                    (
                        ($(this).attr('type').toLowerCase()=="date") 
                        ||($(this).attr('type').toLowerCase()=="time") 
                    )
                    && $(this).val()
                ) return;
            } catch(e) {}
            fm._scrollTo();
        });
        $(document).delegate('form '+this.selector+' input[type="date"], form '+this.selector+' input[type="time"]', 'blur', function(e){
           fm.validateFormElement($(this).closest(fm.selector));
           if ( $(this).val()) fm._scrollTo();
        });            

    }
    
    _scrollTo(){
        var el = $('.alert-form-element');
        var selector='html, body';
        if(el.length>0) {
            if (el.first()[0].matches('.fancybox-inner *, .vutbox-inner *')) return;
            console.log(el.first()[0]);
            $(selector).animate({
                scrollTop: el.first().offset().top - 10
            }, 500);
        }
    }
    
    validateFormElement(group){
        $(this.options.alertSelector, group).remove();
        var schvalen = true;
        var elementy = $('input[type=number],input[type=text],input[type=date],input[type=time],input[type=file],input[type=password],textarea,select', group);

        if(elementy.size()>0){
            if(elementy.val() === null || !(elementy.val().length>0)){
                schvalen = false;
                this.showMessage(elementy.get(0));
                $(group).addClass('has-warning').addClass('has-alert');
            }else{
                this.removeClass(group);
            }
        }else if( $('input:checked', group).size() == 0 ) {
            schvalen = false;
            this.showMessage($('.checkbox,.radio', group).get(0));
            $(group).addClass('has-warning').addClass('has-alert');
        }else{
            this.removeClass(group);
        }
        return schvalen;
    }
    
    validateForm(form){
        // 1 kontrola jestli existuji elementy s nastavenym required
        try{
            var schvalen = true;
            var fm = this;
            $(this.selector, form).each(function(k,group){
                var ret = fm.validateFormElement(group);
                schvalen = schvalen && ret ;
            });
            if(!schvalen ){
                return false;
            }
            return true;
        }catch(er){
            console.log(er);
            return false;
        }
        return true;
    }
    
    removeClass(group){
        $(group).removeClass('has-warning');
        if($('.alert', group).count =='function' && $('.alert', group).count()==0){
            // odstranujeme pouze pokud uz nejsou jine hlasky kolem elementu
            $(group).removeClass('has-alert');
        }
    }

    showMessage(el){
        var msg;
        if(this.langCode=='cs'){
            msg = 'Údaj je povinný a musí být vyplněn';
        }else{
            msg = 'Value is required and can\'t be empty';
        }
        //msg = '<div class="alert alert-warning alert-form-element alert-required"><div><span class="icon icon-16 icon-16-warn"></span> '+msg+'</div></div>';
        msg = '<div class="alert alert-warning alert-form-element alert-required"><div class="alert-icon"><span class="icon-notification2" aria-hidden="true"></span></div><div class="alert-text">'+msg+'</div></div>';
        var element = $(el);

        if(element.attr('type')=="file" && element.closest('.vut-file')){
            element.closest('.vut-file').before(msg);

/*      //// starej kombobox; novej na to nereaguje a kdyby reagoval, tak by ho to rozbilo
        }else if(element.hasClass('combobox') && element.siblings('.custom-combobox').length){ 
            element.siblings('.custom-combobox').before(msg);
*/
        } else {
            $(el).before(msg);
        }
    }
}
